import type { RoleView } from './role-view.type.ts';
export interface RoleViewExtension extends RoleView {}
export class RoleViewExtension {
  // ── Computed Properties ──
  get roleType() {
    return this.role;
  }
}

const Registration = {
  kind: 'object',
  name: 'role-view',
  features: RoleViewExtension,
};
export default Registration;
